// extracted by css-extract-rspack-plugin
export default {"tagCloud":"tag-cloud--qng89uJq6k4f1H5J"};